import React from "react";
import {
  LayoutDashboard, Archive, ScanText, Sparkles, Network, Compass,
  Languages, MapPin, ScrollText, CreditCard, Feather, UtensilsCrossed, Leaf, Scroll, Lock, ShieldCheck,
} from "lucide-react";

export const NAV = [
  { id: "tribal_affiliation", label: "Tribal Affiliation", icon: Feather, badge: "AI" },
  { id: "historical_map", label: "Historical Map", icon: MapPin },
  { id: "family_tree", label: "Family Tree", icon: Network },
  { id: "roll_search", label: "Indian Roll Search", icon: ScrollText, badge: "Records" },
  { id: "treaties", label: "Tribal Treaties", icon: Scroll, badge: "New" },
  { id: "tribal_paths", label: "Tribal Research Paths", icon: Compass },
  { id: "language_lab", label: "Language Lab", icon: Languages, badge: "7d" },
  { id: "tribal_recipes", label: "Tribal Recipes", icon: UtensilsCrossed, badge: "Food" },
  { id: "tribal_remedies", label: "Tribal Remedies", icon: Leaf, badge: "Plants" },
  { id: "vault", label: "Ancestral Vault", icon: Archive, badge: "Docs" },
  { id: "record_reader", label: "AI Record Reader", icon: ScanText, badge: "Extract" },
  { id: "journey", label: "Heritage Journey", icon: LayoutDashboard, badge: "Overview" },
  { id: "account", label: "Account & Billing", icon: CreditCard },
  { id: "admin", label: "Admin Portal", icon: ShieldCheck, badge: "Admin", adminOnly: true },
];

export const Sidebar = ({ active, onSelect, open, onClose, lockedIds, isAdmin }) => (
  <>
    {open && (
      <div className="fixed inset-0 z-30 bg-black/40 lg:hidden" onClick={onClose} data-testid="sidebar-backdrop" />
    )}
    <aside
      data-testid="portal-sidebar"
      className={`hp-purple-panel fixed lg:sticky top-0 z-40 h-screen w-72 shrink-0 flex flex-col
        transition-transform duration-300 ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
    >
      <div className="px-6 py-6 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="grid place-items-center h-11 w-11 rounded-xl border border-[#D4AF37]/60 bg-[#180D24]">
            <img src="/logo.png" alt="WhatsMyTribe" className="h-8 w-8 object-contain" />
          </div>
          <div>
            <div className="font-serif text-lg font-bold text-[#FAF8F5] leading-tight">The Heritage Portal</div>
            <div className="text-[10px] uppercase tracking-[0.2em] font-mono text-[#E7C965]">ISelfLawAmMaster</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto hp-scroll px-3 py-4 space-y-1">
        {NAV.filter((item) => !item.adminOnly || isAdmin).map((item) => {
          const Icon = item.icon;
          const isActive = active === item.id;
          const locked = lockedIds ? lockedIds.has(item.id) : false;
          return (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => { onSelect(item.id); onClose?.(); }}
              className={`w-full group flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-colors duration-200
                ${isActive
                  ? "bg-[#D4AF37] text-[#180D24] font-semibold shadow"
                  : locked ? "text-[#9c8fb3] hover:bg-white/5" : "text-[#E9E2F2] hover:bg-white/10"}`}
            >
              <Icon size={18} strokeWidth={isActive ? 2.4 : 2} />
              <span className="flex-1 text-left">{item.label}</span>
              {locked ? (
                <Lock size={13} className="text-[#9c8fb3]" data-testid={`nav-lock-${item.id}`} />
              ) : item.badge ? (
                <span className={`text-[10px] font-mono px-1.5 py-0.5 rounded-md
                  ${isActive ? "bg-[#180D24]/15 text-[#180D24]" : "bg-white/10 text-[#E7C965]"}`}>
                  {item.badge}
                </span>
              ) : null}
            </button>
          );
        })}
      </nav>

      <div className="px-5 py-4 border-t border-white/10">
        <div className="text-[10px] uppercase tracking-[0.16em] font-mono text-[#E7C965] mb-1">Guiding Principle</div>
        <p className="text-[11px] leading-relaxed text-[#CDBFE0]">
          Research → Verify → Understand → Preserve. Evidence, never assumption.
        </p>
        <div className="mt-3 pt-3 border-t border-white/10 text-[10px] text-[#9c8fb3]">
          Powered by <span className="text-[#E7C965] font-medium">ISelfLawAmMaster.com</span>
        </div>
      </div>
    </aside>
  </>
);
